import { useState } from 'react';
import {
  useMyDeclarations,
  useMyAssessments,
  useMyCorrectiveActions,
  useMyCompetencyStatus,
} from '@/api/competency';
import { PositionFilter } from '@/components/shared/position-filter';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { CompetencyMatrixSection } from './_components/competency-matrix-section';
import { DeclarationsSection } from './_components/declarations-section';
import { AssessmentsSection } from './_components/assessments-section';
import { CorrectiveActionsSection } from './_components/corrective-actions-section';
import { MyCertificatesSection } from './_components/my-certificates-section';
import { EvidenceReviewSection } from './_components/evidence-review-section';

export function CompetencyPage() {
  const [positionId, setPositionId] = useState<number | undefined>(undefined);
  const {
    data: declarations,
    isLoading: declLoading,
    error: declError,
  } = useMyDeclarations(positionId);
  const {
    data: assessments,
    isLoading: assLoading,
    error: assError,
  } = useMyAssessments(positionId);
  const {
    data: actions,
    isLoading: actLoading,
    error: actError,
  } = useMyCorrectiveActions(positionId);
  const {
    data: statuses,
    isLoading: statusLoading,
    error: statusError,
  } = useMyCompetencyStatus(positionId);

  const isLoading = declLoading || assLoading || actLoading || statusLoading;
  const hasError = declError || assError || actError || statusError;

  if (isLoading) return <LoadingSpinner />;
  if (hasError) return <ErrorMessage message="No se pudo cargar la información de competencia." />;

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Mi Competencia</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Declaraciones, evaluaciones y acciones correctivas asociadas a tus posiciones.
        </p>
      </div>

      <PositionFilter value={positionId} onChange={setPositionId} />

      <EvidenceReviewSection />
      <CompetencyMatrixSection statuses={statuses} />
      <MyCertificatesSection />
      <DeclarationsSection declarations={declarations} />
      <AssessmentsSection assessments={assessments} />
      <CorrectiveActionsSection actions={actions} />
    </div>
  );
}
